import { MSDriveItem } from "../types/ms-graph";

export const msGraphHelper = {
  buildTreeFromDriveItem(data: MSDriveItem[]) {
    const rootItems: MSDriveItem[] = [];
    const lookup: Record<string, MSDriveItem> = {};

    data.forEach((item) => (lookup[item.id] = { ...item, children: [] }));

    data.forEach((item) => {
      if (!lookup[item.parentReference.id]) {
        rootItems.push(lookup[item.id]);
      } else {
        const parent: MSDriveItem = lookup[item.parentReference.id];
        parent.children?.push(lookup[item.id]);
      }
    });

    return rootItems;
  },

  mapNestedTree<TResult = any>(data: MSDriveItem[], cb?: (item: MSDriveItem) => TResult): TResult[] {
    const callback = cb ? cb : (item: MSDriveItem) => item;
    return data.map((item) => {
      if (item?.children && item?.children?.length > 0) {
        return { ...item, ...callback(item), children: msGraphHelper.mapNestedTree(item.children, cb) };
      }
      return { ...item, ...callback(item) } as any;
    });
  },

  sortNestedTree(data: MSDriveItem[], compare?: (a: MSDriveItem, b: MSDriveItem) => number): MSDriveItem[] {
    const root = data.map((item) => {
      if (item?.children && item?.children?.length > 0) {
        return { ...item, children: msGraphHelper.sortNestedTree(item.children, compare) };
      }
      return item;
    });
    return root.sort(compare);
  },
};
